import React from 'react';
import { connect } from 'react-redux';
import { ReduxCompatibleDispatch } from 'lib/redux-stabilizer';
import { MainAction } from 'module/Redux/Main';

type DispatchProps = {
  setTouchDetected: (val: boolean) => void;
};

const mapDispatchToProps = (dispatch: ReduxCompatibleDispatch): DispatchProps => ({
  setTouchDetected: (val: boolean) => dispatch(MainAction.updateTouchDetected(val)),
});

type OwnProps = {};

type Props = DispatchProps & OwnProps;

class TouchDetectComp extends React.PureComponent<Props> {
  constructor(props: Props) {
    super(props);
    this.onTouch = this.onTouch.bind(this);

    (window as any).setTouchDetected = () => props.setTouchDetected(true);
    // this.onMouseover = this.onMouseover.bind(this);
  }

  componentDidMount() {
    window.addEventListener('touchstart', this.onTouch);
  }

  componentWillUnmount() {
    window.removeEventListener('touchstart', this.onTouch);
    // window.removeEventListener('mouseover', this.onMouseover);
  }

  render() {
    return React.Children.only(this.props.children);
  }

  private onTouch() {
    this.props.setTouchDetected(true);
    window.removeEventListener('touchstart', this.onTouch);
    // window.addEventListener('mouseover', this.onMouseover);
  }
}

export const TouchDetect = connect(null, mapDispatchToProps)(TouchDetectComp);



// WEBPACK FOOTER //
// ./src/module/View/Common/component/TouchDetect/index.tsx